import { IDeliverySpec } from '@/shared/model/delivery-spec.model';
import { IDiscount } from '@/shared/model/discount.model';
import { IRestaurantCategory } from '@/shared/model/restaurant-category.model';

export interface IRestaurantList {
  id: number;
  name: string;
  deliver: boolean;
  pickup: boolean;
  image: string;
  imageContentType: string;
  logo: string;
  logoContentType: string;
  deliverySpec: IDeliverySpec;
  foodDiscount: IDiscount;
  nonfoodDiscount: IDiscount;
  ratingSummary: { average: number; ratings: number };
  restaurantCategories: any[];
}

export interface Types {
  deliver: boolean;
  pickup: boolean;
}

export interface Costs {
  free: boolean;
  all: boolean;
}

export interface MinDeliveries {
  noPreference: boolean;
  all: boolean;
}

export enum SortByTypes {
  DISCOUNT = 'DISCOUNT',
  REVIEW = 'REVIEW',
  DISTANCE = 'DISTANCE',
  POPULARITY = 'POPULARITY',
  DELIVERY_COSTS = 'DELIVERY_COSTS',
  DELIVERY_TIME = 'DELIVERY_TIME',
  MIN_ORDER_AMOUNT = 'MIN_ORDER_AMOUNT',
  ALPHABETICAL = 'ALPHABETICAL',
}

export interface IRestaurants {
  restaurants: IRestaurantList[];
  categories: IRestaurantCategory[];
  selectedCategory: number;
  types: Types;
  ratings: number;
  costs: Costs;
  minDeliveries: MinDeliveries;
  sortBy: SortByTypes;
  search: string;
}

export class RestaurantList implements IRestaurantList {
  constructor(
    public id: number,
    public name: string,
    public deliver: boolean,
    public pickup: boolean,
    public image: string,
    public imageContentType: string,
    public logo: string,
    public logoContentType: string,
    public deliverySpec: IDeliverySpec,
    public foodDiscount: IDiscount,
    public nonfoodDiscount: IDiscount,
    public ratingSummary: { average: number; ratings: number },
    public restaurantCategories: any[]
  ) {}
}
